import {ComponentProps} from 'react';
import {Control, FieldValues, Path, useController} from 'react-hook-form';

import {Checkbox} from 'components/Checkbox/Checkbox';

type Props<T extends FieldValues> = {
    control: Control<T>;
    name: Path<T>;
} & Omit<ComponentProps<typeof Checkbox>, 'onCheck' | 'checked' | 'name'>;

export function CheckboxHookForm<T extends FieldValues>({
    control,
    ...checkboxProps
}: Props<T>) {
    const {field} = useController({
        name: checkboxProps.name,
        control,
    });

    return (
        <Checkbox
            {...checkboxProps}
            onCheck={field.onChange}
            checked={field.value}
        />
    );
}
